import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 tenant_add_backdated_order_products: { message: "idle" },
};

export const tenant_add_backdated_order_products_Slice = createSlice({
 name: "tenant_add_backdated_order_products",
 initialState,
 reducers: {
  success_tenant_add_backdated_order_products: (state, action) => {
   state.tenant_add_backdated_order_products = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_tenant_add_backdated_order_products: (state, action) => {
   state.tenant_add_backdated_order_products = { status: app_consts.FAIL, message: action.payload };
  },
  reset_tenant_add_backdated_order_products: (state) => {
   state.tenant_add_backdated_order_products = { status: app_consts.IDLE };
  },
  loading_tenant_add_backdated_order_products: (state) => {
   state.tenant_add_backdated_order_products = { status: app_consts.LOADING };
  },
 }
});

export const { success_tenant_add_backdated_order_products, fail_tenant_add_backdated_order_products, reset_tenant_add_backdated_order_products, loading_tenant_add_backdated_order_products } = tenant_add_backdated_order_products_Slice.actions;

export default tenant_add_backdated_order_products_Slice.reducer;